// Libraries
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const shouldShowReactQueryDevToolsAtom = atomWithStorage( 'showReactQueryDevTools', false );
const shouldShowAmpliLogsAtom = atomWithStorage( 'shouldShowAmpliLogs', false );

export const useShouldShowReactQueryDevToolsToggle = () => useAtom( shouldShowReactQueryDevToolsAtom );
export const useShouldShowAmpliLogsToggle = () => useAtom( shouldShowAmpliLogsAtom );
